document.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('blog-posts-grid');
  if (!grid) return; // silent exit if grid doesn't exist

  const paginationEl = document.getElementById('blog-pagination');
  const parser = new DOMParser();
  let isLoading = false;
  let abortController = new AbortController(); // if user is trigger happy when navigating pages

  const LOADING_SVG = `
    <div class="blog-posts__loading">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
      </svg>
    </div>
  `;

  const resetOpacity = () => {
    grid.style.opacity = '1';
    grid.querySelectorAll('.blog-post-item').forEach(item => {
      const el = /** @type {HTMLElement} */ (item);
      el.style.opacity = '1';
    });
  };

  const showLoading = () => {
    grid.style.opacity = '0.4';
    grid.innerHTML = LOADING_SVG;
  };
  
  /** @param {string} url */
  const loadPage = async (url) => {
    if (isLoading) return;
    isLoading = true;

    abortController?.abort();
    abortController = new AbortController();

    showLoading();

    try {
      // ensure scrolls to top happens first so the screen is never just blank
      const gridTop = grid.getBoundingClientRect().top + window.scrollY - 20;
      window.scrollTo({ top: gridTop, behavior: 'smooth' });

      const [res] = await Promise.all([
        fetch(url, { signal: abortController.signal }),
        new Promise(resolve => setTimeout(resolve, 750))
      ]); // setTimeout for consistent experience

      const html = await res.text();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.getElementById('blog-posts-grid');
      const newPagination = doc.getElementById('blog-pagination');

      if (newGrid) {
        grid.innerHTML = newGrid.innerHTML; // build grid
        resetOpacity(); // ensure items show
      }

      if (newPagination && paginationEl) {
        paginationEl.innerHTML = newPagination.innerHTML;
      }
    } catch (err) {
      if (err.name !== 'AbortError') resetOpacity();
    } finally {
      isLoading = false;
    }
  };

  document.addEventListener('click', (e) => {
    const target = /** @type {HTMLElement} */ (e.target);
    const link = /** @type {HTMLAnchorElement | null} */ (target?.closest('a.blog-pagination__btn'));
    if (!link) return;
    e.preventDefault();
    window.history.pushState({}, '', link.href);
    loadPage(link.href);
  });

  window.addEventListener('popstate', () => loadPage(window.location.href));
});
